/*
 * scaReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 20-Jan-2025
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/sca'
import { resetHeaders } from 'Store/middleware/sca'
import { nullSafe } from 'Utility/globalMethods'

const ACTION_HANDLERS = {
  [actionTypes.DO_SAVE_ACTION_TYPE_AND_PAYLOAD]: produce((draft, action) => {
    draft.captureAndHandleSca = true
    draft.nextAction = {
      actionToInvoke: action.actionToInvoke,
      actionPayload: action.actionPayload
    }
  }),
  [actionTypes.DO_SAVE_PERSISTENT_DATA]: produce((draft, action) => {
    draft.persistentData = action.payload
  }),
  [actionTypes.DO_SAVE_TRACK_REQUEST_ACTION]: produce((draft, action) => {
    draft.trackRequestAction = action.payload
  }),
  [actionTypes.DO_RESET_STATE]: produce((draft) => {
    // Don't reset nextAction if we're in the middle of SCA flow
    const preserveNextAction = draft.nextAction && draft.nextAction.actionToInvoke &&
      draft.nextAction.actionToInvoke.includes('check_otp_aml')

    // reset the headers
    resetHeaders()

    draft.captureAndHandleSca = false
    if (!preserveNextAction) {
      draft.nextAction = null
    }
    draft.trackRequestAction = null
    draft.error = null
    draft.persistentData = null
    draft.otpType = ''
  }),
  [actionTypes.DO_SAVE_ERROR]: produce((draft, action) => {
    draft.error = action.payload || '-1' // -1 is a generic error
  }),
  [actionTypes.DO_REGENERATE_OTP]: produce((draft) => {
    draft.error = ''
  }),
  [actionTypes.DO_RESET_SCA_ERROR]: produce((draft) => {
    draft.error = ''
  }),
  [actionTypes.CHECK_OTP_AML_FAILURE]: produce((draft, action) => {
    draft.scaMaskedPhone = nullSafe(() => action.error.data.maskedData[0].obfuscatedValue, draft.scaMaskedPhone)
  }),
  [actionTypes.DO_SAVE_OTP_TYPE]: produce((draft, action) => {
    draft.otpType = action.otpType
  })
  // @generator reducer:type:action
}

// The initial state of the sca
const initialState = {
  captureAndHandleSca: false,
  nextAction: null,
  trackRequestAction: null,
  error: null,
  persistentData: null,
  scaMaskedPhone: '',
  otpType: ''
}

const sca = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default sca
